<template>
  <div class="com-box" :style="{height: isEdit ? null : pagesHeight}">
    <div class="front" :class="{'active-front': isEdit}" ref="element">
      <div class="head" v-if="!isApplayTemp">
        <div class="head-left">
          <div class="item" v-if="cmpIndex != 0" @click="moveUp">上移</div>
          <div class="item" v-if="comListLength != cmpIndex" @click="shiftDown">下移</div>
          <div class="item" v-if="comListLength > 0" @click="delCmp">删除</div>
        </div>
        <div class="head-right" @click="edit">编辑</div>
      </div>
      <preview-group-buy :comData="formData" v-show="!isEdit" :tmpType="tmpType"/>
      <div style="height: 20px;"></div>
    </div>
    <div class="back" :class="{'active-back': isEdit}">
      <group-buy v-model="formData" ref="groupBuying" @goodsHandler="goodsHandler"/>
      <div style="height: 60px;"></div>
      <div class="footer">
        <div class="footer-item call" @click="cancel">取消</div>
        <div class="footer-item" @click="save">保存</div>
      </div>
    </div>
  </div>
</template>

<script>
import previewGroupBuy from '@/pages/activity-home/components/group-buy'
import groupBuy from '../../components/group-buy'
import _ from 'loadsh'
export default {
  components: {
    previewGroupBuy,
    groupBuy
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: Object,
    cmpIndex: Number,
    comListLength: Number,
    isApplayTemp: Boolean,
    tmpType: Number
  },
  computed: {
    // 是否编辑
    isEditActivity() {
      return this.$route.query.from == 'manager' ? true : false
    }
  },
  watch: {
    value: {
      handler(newVal) {
        this.formData = _.cloneDeep(newVal)
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      isEdit: false,
      formData: {},
      pagesHeight: '268px',
    }
  },
  mounted() {
    // 获取组件高度
   this.$nextTick(()=> {
    let height = window.getComputedStyle(this.$refs.element).height
    this.pagesHeight = height  == '0px' ? '268px' : height 
   })
  },
  methods: {
    edit() {
      this.isEdit = true
      this.$emit('handle',['groupBuying',false])
    },
    cancel() {
      this.formData = _.cloneDeep(this.value)
      this.isEdit = false
      this.$emit('handle', ['groupBuying',true])
    },
    save() {
      this.$refs.groupBuying.submit().then(res => {
        this.$emit('change', this.formData)
        this.isEdit = false
        this.$nextTick(()=> {
          this.pagesHeight = window.getComputedStyle(this.$refs.element).height
          this.$emit('handle', ['groupBuying',true])
        })
      })
    },
    // 发布的活动 上下架 删除 直接改变父组见数据
    goodsHandler(goodsIndex,goods,del) {
      if (del) {
        this.value.goods.splice(goodsIndex, 1)
      }else {
        this.value.goods[goodsIndex] = goods
      }
    },
    submit() {
      // false 参数校验不通过禁止提示
      return this.$refs.groupBuying.submit(false)
    },
    delCmp() {
      this.$emit('delCmp',this.cmpIndex)
    },
    moveUp() {
      this.$emit('moveUp',this.cmpIndex)
    },
    shiftDown() {
      this.$emit('shiftDown',this.cmpIndex)
    }
  }
}
</script>

<style lang="stylus" scoped>
.com-box {
  position: relative;
  perspective: 800px;
  overflow hidden
  padding: 10px 0;
  box-sizing: border-box;
  .front {
    position: absolute;
    left: 0;
    right: 0;
    transition: 1s;
    z-index: 1;
    backface-visibility: hidden;
    .head {
      position: absolute;
      top: 10px;
      left: 10px;
      width: 95%;
      display: flex;
      justify-content: space-between;
      z-index: 9;
      .head-left {
        display: flex;
        .item {
          padding: 4px;
          border-radius: 3px;
          background: #fff;
          margin-right: 10px;
        }
      }
      .head-right {
        padding: 4px;
        border-radius: 3px;
        background: #fff;
      }
    }
  }
  .back {
    transform: rotateY(-180deg);
    backface-visibility: hidden;
    transition: 1s;
    margin-top: -10px;
    background: #fff;
    z-index: 99999;
    .footer {
      display: flex;
      justify-content center;
      width: 100%;
      padding: 10px 0;
    }
    .footer-item {
      color: #FFFFFF;
      padding: 10px 26px;
      border-radius: 4px;
      background: #FF6B31;
      margin-left: 20px;
    }
    .call {
      color: #FF6B31;
      background: #F4F4F4;
    }
  }
  .active-front {
    transform: rotateY(180deg);
  }
  .active-back {
    transform: rotateY(0deg);
  }
}
  
</style>